import { Form as FormikForm } from "formik"
import styled from "styled-components"

import { media } from "../../styles"

const Form = styled(FormikForm)`
  position: relative;

  [data-name^="col"] {
    @media ${media.md} {
      padding: 0 15px;

      &:first-child {
        padding-left: 10px;
      }

      &:last-child:not(:first-child) {
        padding-right: 10px;
      }
    }
  }
`

export default Form
